import React, {Component} from 'react'
import PropTypes from "prop-types"
import _ from 'lodash'
import NRTHorizontalStack from "../../../../components/_common/_containers/HorizontalStack"
import NRTVerticalStack from "../../../../components/_common/_containers/VerticalStack"
import NRTButton from "../../../../components/_common/_buttons/Button"
import NRTTable from "../../../../components/_common/Table"
import NRTFormStateManager from "../../../../components/_common/_form/FormStateManager"
import {Validators} from "../../../../components/_common/_form/Validators"
import CircleMinus from "../../../../components/_common/_icons/CircleMinus"
import NRTSaleActionBar from "../../../../components/_sale/ActionButtonBar"
import MCSaleFormGuest from "../../../../components/_sale/FormGuest"
import BackButton from "../../../../components/_common/_buttons/BackButton"
import PersonRequests from "../../../../requests/person-requests"
import MCLoadingOverlay from "../../../../components/_minha-central/LoadingOverlay"


class GuestsStep extends Component {


    static EMAIL_ALREADY_IN_USE = 'O email informado já está sendo utilizado por outro ' +
        'usuário.'

    static UNKNOWN_ERROR = 'Ocorreu um erro ao salvar dados do participante.'

    state = {
        awaiting: false,
        activeGuest: {},
        guests: [],
        form: {}
    }

    personDTO = {}
    lastSearchedCPF = ''
    preventLeaving = false


    componentDidMount() {


        const responsible = _.get(this.props, 'context.saleResponsible', null)
        const guestsAlreadyAdded = _.get(this.props, 'context.saleGuests', null)

        if (guestsAlreadyAdded) {
            this.setState({
                guests: guestsAlreadyAdded
            })
        } else if (responsible) {

            if (!responsible.legal)
                this.setState({guests: [{...responsible}]})
        }


    }


    formChanged = (form) => {

        this.setState({form})

        const cpf = _.get(form, 'values.cpfCnpj', '')

        if (
            cpf &&
            cpf !== this.lastSearchedCPF &&
            !Validators.cpf()(cpf)
        )
            this.getGuestInfo(cpf)

    }


    getGuestInfo(cpf) {

        this.lastSearchedCPF = cpf

        PersonRequests
            .search({cpfCnpj: cpf})
            .then(person => {
                if (person) {
                    this.personDTO = person
                    this.formGuest.updateGuestInfo(person)
                } else {

                    this.personDTO = {}
                    this.formGuest.reset()
                }

            })
            .catch((err) => {
                console.error(err)
                this.props.context.set({
                    toastMessage: {
                        type: 'error',
                        content: 'Erro ao tentar buscar as informações do participante.'
                    }
                })
                this.preventLeaving = false
            })

    }


    _addGuest = (formRef, personDto) => {


        const {form} = this.state
        formRef.validate()

        if (!form.valid || form.dirty === false)
            return


        if (this.state.guests.some(guest => guest.cpfCnpj === form.values.cpfCnpj))
            return


        this.setState({awaiting: true})
        this.props.savePerson({
            login: `${this.props.context.credentials.schema}.${form.values.cpfCnpj}`,
            types: '2',
            type: 2,
            ...personDto,
            ...form.values,

        })
            .then((person) => {

                this.setState({awaiting: false})

                const errorMessages = _.get(person, 'errorMessages', [])


                if (errorMessages.length > 0) {
                    if ((errorMessages[0] + '').indexOf('Email') >= 0)
                        return this.onError(GuestsStep.EMAIL_ALREADY_IN_USE)

                    return this.onError(GuestsStep.UNKNOWN_ERROR)
                }

                if (!_.get(person, 'cpfCnpj', false))
                    return

                this.personDTO = {}
                this.setState(state => ({
                        guests: [
                            ...state.guests,
                            {...person}
                        ],
                        form: {},

                    }), () => {
                        this.props.context.set({saleGuests: this.state.guests})
                        formRef.reset()
                    }
                )

            })
            .catch((err) => {
                console.error(err)
                this.setState({awaiting: false})

                this.props.context.set({
                    toastMessage: {
                        type: 'error',
                        content: 'Desculpe, houve um erro ao tentar salvar os dados do participante.'
                    }
                })
            })
    }

    addGuest = _.debounce(this._addGuest, 200)


    removeGuest = (row) => {
        this.setState(state => ({
            guests: state.guests.filter(guest => guest.name !== row.name)
        }), ()=>{
            this.props.context.set({saleGuests: this.state.guests})
        })
    }


    finishGuestsStep = _.debounce(() => {

        if (this.state.awaiting)
            return


        if (!this.state.guests.length) {

            this.props.context.set({
                toastMessage: {
                    type: "warning",
                    content: "Por favor, insira ao menos um participante.",
                }
            })


        } else {
            this.props.context.set(
                {
                    saleGuests: this.state.guests
                },
                () => this.props.goToNextStep()
            )

        }


    }, 200)


    onError(message) {
        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: message,
            }
        })
    }


    render() {

        const {activeGuest, awaiting} = this.state

        return (
            <NRTVerticalStack style={{position: 'relative'}}>

                <MCLoadingOverlay show={awaiting}/>
                <BackButton onClick={this.props.goToPreviousStep}/>

                <NRTHorizontalStack smFractions={[1]}>

                    {/*Form - Add participante*/}
                    <NRTFormStateManager
                        ref={f => this.form = f}
                        onStateChange={this.formChanged}
                    >

                        <MCSaleFormGuest
                            ref={f => this.formGuest = f}
                            onAddGuest={() => this.addGuest(this.form, this.personDTO)}
                            guest={activeGuest}
                        />

                    </NRTFormStateManager>

                    {/*Lista de participantes*/}
                    {
                        this.state.guests.length > 0 &&
                        <NRTTable
                            data={this.state.guests}
                            headers={[
                                {
                                    title: 'Nome',
                                    fieldName: 'name',
                                },
                                {
                                    title: 'Email',
                                    fieldName: 'email',
                                },
                                {
                                    title: 'Telefone',
                                    fieldName: 'phoneOne',
                                },
                            ]}


                            buttons={[

                                <NRTButton
                                    iconButton
                                    secondary
                                    onClick={this.removeGuest}
                                >
                                    <CircleMinus/>
                                </NRTButton>,
                            ]}
                        />
                    }

                </NRTHorizontalStack>

                <NRTSaleActionBar

                    onClick={this.finishGuestsStep}
                />

            </NRTVerticalStack>
        )
    }
}

GuestsStep.propTypes = {
    context: PropTypes.object.isRequired,
    goToNextStep: PropTypes.func.isRequired,
    goToPreviousStep: PropTypes.func.isRequired,
    savePerson: PropTypes.func.isRequired,
}

GuestsStep.defaultProps = {}


export default GuestsStep



// WEBPACK FOOTER //
// ./src/_pages/Sale/_partials/GuestsStep/index.js